export default (req) => ({
  getOrderSettings: () => req.get("/order/management/setting"),
  updateOrderSettings: (body) => req.put("/order/management/setting", body),
});
